import Vue from "vue";

export const services = {
  getLoggedInUser() {
    return Vue.http.get("api/user");
  },

  getCurrentUserWeights() {
    return Vue.http.get("api/weight");
  },
  addCurrentUserWeight(value, date) {
    return Vue.http.post("api/weight", { value, date });
  },

  getCalories() {
    return Vue.http.get("api/calories");
  },

  getSleep() {
    return Vue.http.get("api/sleep");
  },

  updateLimits(limits) {
    return Vue.http.put("api/limits", limits);
  },

  updateOauthToken(code, appName) {
    return Vue.http.post("api/updateOauthToken", { code, appName });
  },

  getGoogleHealthAuthorizationUrl() {
    return Vue.http.get("api/google-health/authorization-url");
  },

  completeGoogleHealthAuthorization(code, state) {
    return Vue.http.post("api/google-health/authorization", { code, state });
  },
};
